import { useId } from "react"

const ELTPipelineIllustration = ({ paused = false }: { paused?: boolean }) => {
  const id = useId()
  const glowId = `elt-line-glow-${id}`

  return (
    <svg
      width="379"
      height="281"
      viewBox="0 0 379 281"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-fg-secondary opacity-40"
      style={{ animationPlayState: paused ? "paused" : "running" }}
    >
      <defs>
        <filter id={glowId} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
        @keyframes elt-highlight {
          0%, 8% { opacity: 0; }
          10% { opacity: 1; }
          20% { opacity: 1; }
          28%, 100% { opacity: 0; }
        }
        @keyframes elt-center-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
        .elt-glow-1 { animation: elt-highlight 6s ease-in-out infinite; animation-play-state: inherit; }
        .elt-glow-2 { animation: elt-highlight 6s ease-in-out 1s infinite; animation-play-state: inherit; }
        .elt-glow-3 { animation: elt-highlight 6s ease-in-out 2s infinite; animation-play-state: inherit; }
        .elt-glow-4 { animation: elt-highlight 6s ease-in-out 3s infinite; animation-play-state: inherit; }
        .elt-glow-5 { animation: elt-highlight 6s ease-in-out 4s infinite; animation-play-state: inherit; }
        .elt-glow-6 { animation: elt-highlight 6s ease-in-out 5s infinite; animation-play-state: inherit; }
        .elt-center { animation: elt-center-pulse 3s ease-in-out infinite; animation-play-state: inherit; }
      `}
      </style>

      {/* Left cards */}
      <path
        d="M92.4269 60.082H40.7275C38.0082 60.082 35.8037 62.2865 35.8037 65.0058V98.2412C35.8037 100.96 38.0082 103.165 40.7275 103.165H92.4269C95.1463 103.165 97.3507 100.96 97.3507 98.2412V65.0058C97.3507 62.2865 95.1463 60.082 92.4269 60.082Z"
        stroke="currentColor"
      />
      <path d="M45.6514 72.3906H87.5033" stroke="currentColor" />
      <path d="M45.6514 82.2383H78.8867" stroke="currentColor" />
      <path d="M45.6514 92.0859H82.5796" stroke="currentColor" />
      <path
        d="M92.4269 115.473H40.7275C38.0082 115.473 35.8037 117.677 35.8037 120.396V153.632C35.8037 156.351 38.0082 158.556 40.7275 158.556H92.4269C95.1463 158.556 97.3507 156.351 97.3507 153.632V120.396C97.3507 117.677 95.1463 115.473 92.4269 115.473Z"
        stroke="currentColor"
      />
      <path d="M45.6514 127.781H85.0414" stroke="currentColor" />
      <path d="M45.6514 137.629H72.732" stroke="currentColor" />
      <path d="M45.6514 147.477H89.9652" stroke="currentColor" />
      <path
        d="M92.4269 170.867H40.7275C38.0082 170.867 35.8037 173.072 35.8037 175.791V209.026C35.8037 211.746 38.0082 213.95 40.7275 213.95H92.4269C95.1463 213.95 97.3507 211.746 97.3507 209.026V175.791C97.3507 173.072 95.1463 170.867 92.4269 170.867Z"
        stroke="currentColor"
      />
      <path d="M45.6514 183.176H80.1177" stroke="currentColor" />
      <path d="M45.6514 193.023H87.5033" stroke="currentColor" />
      <path d="M45.6514 202.871H75.1939" stroke="currentColor" />

      {/* Center transform icon */}
      <path
        d="M222.658 97H156.187C150.749 97 146.34 101.409 146.34 106.848V173.318C146.34 178.757 150.749 183.166 156.187 183.166H222.658C228.097 183.166 232.506 178.757 232.506 173.318V106.848C232.506 101.409 228.097 97 222.658 97Z"
        stroke="currentColor"
      />
      <path
        className="elt-center"
        d="M213.088 116.21C214.33 117.41 215.149 118.987 215.34 120.713C215.34 121.43 215.149 121.914 214.713 122.815C214.277 123.723 208.966 132.915 207.377 135.459C206.469 136.952 205.991 138.72 205.991 140.44C205.991 142.16 206.475 143.934 207.377 145.421C208.954 147.966 214.277 157.199 214.713 158.125C215.149 159.033 215.34 159.469 215.34 160.185C215.149 161.911 214.39 163.488 213.13 164.641C211.929 165.883 210.352 166.701 208.673 166.851C207.956 166.851 207.472 166.66 206.612 166.224C205.752 165.788 180.638 151.274 180.638 151.274C180.931 153.669 181.982 155.969 183.708 157.647C184.043 157.982 184.383 158.274 184.76 158.555C184.467 158.698 172.071 165.937 171.151 166.373C170.243 166.809 169.807 167 169.049 167C167.322 166.809 165.745 166.05 164.592 164.79C163.349 163.59 162.531 162.013 162.34 160.287C162.382 159.57 162.591 158.854 162.967 158.226C163.403 157.319 168.714 148.067 170.303 145.523C171.211 144.03 171.689 142.31 171.689 140.542C171.689 138.774 171.205 137.048 170.303 135.561C168.726 132.933 163.361 123.675 162.967 122.774C162.585 122.147 162.4 121.43 162.34 120.713C162.531 118.987 163.29 117.41 164.55 116.21C165.751 114.968 167.328 114.191 169.054 114C169.771 114.042 170.488 114.251 171.157 114.627C171.916 114.962 196.976 129.738 196.976 129.738C196.684 126.871 195.274 124.279 192.962 122.511C193.141 122.415 205.585 115.039 206.51 114.645C207.138 114.263 207.855 114.078 208.613 114.018C210.292 114.209 211.875 114.968 213.07 116.228L213.1 116.216L213.088 116.21ZM189.73 144.973L193.314 141.378C193.81 140.876 193.81 140.13 193.314 139.61L189.73 136.015C189.234 135.513 188.487 135.513 187.968 136.015L184.383 139.61C183.887 140.112 183.887 140.858 184.383 141.378L187.968 144.973C188.41 145.415 189.21 145.415 189.73 144.973Z"
        fill="currentColor"
      />

      {/* Right cards */}
      <path
        d="M338.612 60.082H286.913C284.194 60.082 281.989 62.2865 281.989 65.0058V98.2412C281.989 100.96 284.194 103.165 286.913 103.165H338.612C341.332 103.165 343.536 100.96 343.536 98.2412V65.0058C343.536 62.2865 341.332 60.082 338.612 60.082Z"
        stroke="currentColor"
      />
      <path
        d="M331.227 69.9297H294.299C292.939 69.9297 291.837 71.0319 291.837 72.3916V74.8534C291.837 76.2131 292.939 77.3153 294.299 77.3153H331.227C332.587 77.3153 333.689 76.2131 333.689 74.8534V72.3916C333.689 71.0319 332.587 69.9297 331.227 69.9297Z"
        fill="currentColor"
      />
      <path
        d="M331.227 82.2383H294.299C292.939 82.2383 291.837 83.3405 291.837 84.7002V87.162C291.837 88.5217 292.939 89.6239 294.299 89.6239H331.227C332.587 89.6239 333.689 88.5217 333.689 87.162V84.7002C333.689 83.3405 332.587 82.2383 331.227 82.2383Z"
        fill="currentColor"
      />
      <path
        d="M338.612 115.473H286.913C284.194 115.473 281.989 117.677 281.989 120.396V153.632C281.989 156.351 284.194 158.556 286.913 158.556H338.612C341.332 158.556 343.536 156.351 343.536 153.632V120.396C343.536 117.677 341.332 115.473 338.612 115.473Z"
        stroke="currentColor"
      />
      <path
        d="M331.227 125.32H294.299C292.939 125.32 291.837 126.423 291.837 127.782V130.244C291.837 131.604 292.939 132.706 294.299 132.706H331.227C332.587 132.706 333.689 131.604 333.689 130.244V127.782C333.689 126.423 332.587 125.32 331.227 125.32Z"
        fill="currentColor"
      />
      <path
        d="M331.227 137.629H294.299C292.939 137.629 291.837 138.731 291.837 140.091V142.553C291.837 143.912 292.939 145.015 294.299 145.015H331.227C332.587 145.015 333.689 143.912 333.689 142.553V140.091C333.689 138.731 332.587 137.629 331.227 137.629Z"
        fill="currentColor"
      />
      <path
        d="M338.612 170.867H286.913C284.194 170.867 281.989 173.072 281.989 175.791V209.026C281.989 211.746 284.194 213.95 286.913 213.95H338.612C341.332 213.95 343.536 211.746 343.536 209.026V175.791C343.536 173.072 341.332 170.867 338.612 170.867Z"
        stroke="currentColor"
      />
      <path
        d="M331.227 180.711H294.299C292.939 180.711 291.837 181.813 291.837 183.173V185.635C291.837 186.994 292.939 188.097 294.299 188.097H331.227C332.587 188.097 333.689 186.994 333.689 185.635V183.173C333.689 181.813 332.587 180.711 331.227 180.711Z"
        fill="currentColor"
      />
      <path
        d="M331.227 193.023H294.299C292.939 193.023 291.837 194.126 291.837 195.485V197.947C291.837 199.307 292.939 200.409 294.299 200.409H331.227C332.587 200.409 333.689 199.307 333.689 197.947V195.485C333.689 194.126 332.587 193.023 331.227 193.023Z"
        fill="currentColor"
      />

      {/* Left dashed lines (base) */}
      <path
        d="M103.68 82C121.995 82 121.995 115 140.68 115"
        stroke="currentColor"
        strokeDasharray="4.92 3.69"
      />
      <line
        x1="103.68"
        y1="139.523"
        x2="140.68"
        y2="139.523"
        stroke="currentColor"
        strokeDasharray="4.92 3.69"
      />
      <path
        d="M103.68 199C121.995 199 121.995 159 140.68 159"
        stroke="currentColor"
        strokeDasharray="4.92 3.69"
      />

      {/* Right dashed lines (base) */}
      <path
        d="M275.68 81.5938C257.365 81.5938 257.365 114.594 238.68 114.594"
        stroke="currentColor"
        strokeDasharray="4.92 3.69"
      />
      <line
        y1="-0.5"
        x2="37"
        y2="-0.5"
        transform="matrix(-1 0 0 1 275.68 139.617)"
        stroke="currentColor"
        strokeDasharray="4.92 3.69"
      />
      <path
        d="M275.68 198.594C257.365 198.594 257.365 158.594 238.68 158.594"
        stroke="currentColor"
        strokeDasharray="4.92 3.69"
      />

      {/* Glow overlays — one per line, staggered */}
      <path
        className="elt-glow-1"
        d="M103.68 82C121.995 82 121.995 115 140.68 115"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4.92 3.69"
        filter={`url(#${glowId})`}
        opacity="0"
      />
      <line
        className="elt-glow-2"
        x1="103.68"
        y1="139.523"
        x2="140.68"
        y2="139.523"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4.92 3.69"
        filter={`url(#${glowId})`}
        opacity="0"
      />
      <path
        className="elt-glow-3"
        d="M103.68 199C121.995 199 121.995 159 140.68 159"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4.92 3.69"
        filter={`url(#${glowId})`}
        opacity="0"
      />
      <path
        className="elt-glow-4"
        d="M275.68 81.5938C257.365 81.5938 257.365 114.594 238.68 114.594"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4.92 3.69"
        filter={`url(#${glowId})`}
        opacity="0"
      />
      <line
        className="elt-glow-5"
        y1="-0.5"
        x2="37"
        y2="-0.5"
        transform="matrix(-1 0 0 1 275.68 139.617)"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4.92 3.69"
        filter={`url(#${glowId})`}
        opacity="0"
      />
      <path
        className="elt-glow-6"
        d="M275.68 198.594C257.365 198.594 257.365 158.594 238.68 158.594"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="4.92 3.69"
        filter={`url(#${glowId})`}
        opacity="0"
      />
    </svg>
  )
}

export default ELTPipelineIllustration
